import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  roles: null,
  status: 'idle',
  error: null,
};

const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    getAllRolesStart: (state) => {
      state.status = 'loading';
      state.error = null;
    },
    getAllRolesSuccess: (state, action) => {
      state.status = 'success';
      state.roles = action.payload.data;
      state.error = null;
    },
    getAllRolesFailure: (state, action) => {
      state.status = 'fail';
      state.error = action.payload.message;
    },
  },
});

export const { getAllRolesStart, getAllRolesSuccess, getAllRolesFailure } = roleSlice.actions;

export default roleSlice.reducer;
